import {
  Body1,
  Button,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalRoot,
  UIHeading2,
} from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import clsx from 'clsx';
import * as React from 'react';

import errorImage from './assets/error.png';
import * as styles from './NewbuildingBrokerFallbackModal.css';

interface INewbuildingBrokerFallbackModalProps {
  title: string;
  description: string;
  buttonText: string;
  imageUrl?: string;
  loading: boolean;
  onClose: () => void;
  onRetry: () => void;
}

export const NewbuildingBrokerFallbackModal: React.FC<INewbuildingBrokerFallbackModalProps> = ({
  title,
  description,
  buttonText,
  imageUrl,
  loading,
  onClose,
  onRetry,
}) => {
  const handleOpenChange = React.useCallback(
    (nextOpen: boolean) => {
      if (!nextOpen) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <ModalRoot open onOpenChange={handleOpenChange}>
      <ModalContent size="S">
        <ModalCloseButton title="Закрыть" size="XS" theme="light" icon={<IconActionClose12 />} />
        <ModalBody>
          <div
            className={clsx(styles['container'], loading && styles['semi-transparent'])}
            data-testid="NewbuildingBrokerFallbackModalContent"
          >
            <div
              className={styles['image']}
              style={{ '--image-url': `url(${imageUrl ?? errorImage})` } as React.CSSProperties}
            />
            <div className={styles['text-wrapper']}>
              <UIHeading2 textAlign="center">{title}</UIHeading2>
              <Body1 textAlign="center" color="text-secondary-default">
                {description}
              </Body1>
            </div>
          </div>
        </ModalBody>
        <ModalFooter sticky={false}>
          <div className={styles['button-wrapper']}>
            <Button loading={loading} fullWidth onClick={onRetry}>
              {buttonText}
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </ModalRoot>
  );
};
